export default __webpack_public_path__ + "static/media/VESTIBULAR.f2a72869.png";